import React, { useState, useEffect } from "react";

import { searchBar, searchIcon, searchInput } from "./search.module.css"

import { ReactComponent as SearchIcon } from "../../../assets/searchIcon.svg"

export default props => {
    const [search, setSearch] = useState("")
    const [placeholder, setPlaceholder] = useState("Search Pod members...")
    const handleKeyPress = (e) => {
        if(e.key === 'Enter'){
            props.submit(e.target.value)
        }
    }
    
    // useEffect(() => {
    //     function handleResize() {
    //         if (window.innerWidth < 768) {
    //             setPlaceholder("Search...")
    //         } else {
    //             setPlaceholder("Search Pod members...")
    //         }
    //     }
    //     handleResize()
    //     window.addEventListener('resize', handleResize)
    // })

    return (
        <div className={searchBar}>
            <SearchIcon onClick={() => props.submit(search)} className={searchIcon} />
            
            <input 
                type="text" 
                name="search" 
                placeholder={placeholder}
                onChange={event => setSearch(event.target.value)} 
                onSubmit={() => props.submit(search)}
                onKeyPress={handleKeyPress}
                className={searchInput}
            ></input>
        </div>
    )
}
    


